import { useMemo } from "react";
import { mapToGoalRentSummary } from "web_myplann/Goals/Helpers/mapToGoalRentSummary";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import type { RentPlan } from "web_myplann/Goals/Types/RentPlan";

export const useRentPlan = (goal: GoalDetail): RentPlan | null => {
	return useMemo(() => {
		const rent = mapToGoalRentSummary(goal);
		if (!rent) return null;

		const currentYear = new Date().getFullYear();
		const accumYears = Math.max(1, goal.dueYear - currentYear);
		const drawYears = rent.isPerpetual ? 0 : rent.rentYears;

		return {
			isPerpetual: rent.isPerpetual,
			currentYear,
			accumYears,
			drawYears,
			endYear: rent.isPerpetual ? null : goal.dueYear + drawYears,
			accumFlex: Math.max(1, accumYears),
			drawFlex: rent.isPerpetual
				? Math.max(2, accumYears)
				: Math.max(1, drawYears),
			monthlyRent: rent.monthlyRent,
			savingsTarget: goal.savingsTarget,
			dueYear: goal.dueYear,
			currencyCode: goal.currencyCode,
		};
	}, [goal]);
};
